export const MODELS = [
  { id: 'gemini-nano-banana-2.1', label: 'Nano Banana 2.1 (latest, recommended)' },
  { id: 'gemini-3-pro-image-preview', label: 'Nano Banana Pro (highest quality, slower)' },
  { id: 'gemini-2.5-flash-image', label: 'Nano Banana original (fast, cheap)' },
];

export const DEFAULT_MODEL = MODELS[0].id;

export function buildIconPrompt({ subject }) {
  const what = subject.trim() || 'the subject';
  return (
    `Create an icon of ${what} that matches the style of the attached black outline emoji.` +
    ' Pure black on a pure white background, filling the frame.'
  );
}
